/****************************************************
 * Module Name:  PacketEvaluationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class PacketEvaluationProxy {
    static AddPackageEvaluation = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/packetevaluation",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllEvaluationData = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packetevaluation/all/${kapanid}/${packetid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetLatestEvaluationData = (kapanid, packetid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/packetevaluation/${kapanid}/${packetid}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}